/** SHA-256 hex of arbitrary JSON-serialisable data. */
export async function hashData(data: unknown): Promise<string> {
  const bytes = new TextEncoder().encode(JSON.stringify(data));
  const buf = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(buf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/** Latest meaningful timestamp on a sync row, in ms. */
export function rowTimestamp(r: Record<string, unknown>): number {
  return new Date((r.modified_timestamp ?? r.updated_at ?? r.created_at ?? 0) as string).getTime();
}

/** True when remote row is newer than local (last-write-wins). */
export function remoteWins(
  remote: Record<string, unknown>,
  local: Record<string, unknown>,
): boolean {
  return rowTimestamp(remote) > rowTimestamp(local);
}
